import { formatCountdown } from "@cede/utils";
import { useCountdown } from "@/hooks";

interface CountdownTimerProps {
  endDate: Date;
  isEstimated?: boolean;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({ endDate, isEstimated = false }) => {
  const countdown = useCountdown(endDate);

  if (!countdown) {
    return <span>Loading...</span>;
  }

  return (
    <span>
      {isEstimated && "~"}
      {formatCountdown(countdown, "compact")}
    </span>
  );
};
